export default __webpack_public_path__ + "d3c221258686a5f54e40cbc5d7962067.svg";